import { CallOutlined, ContactMailOutlined, LocationOnOutlined, MailOutlined } from '@mui/icons-material';
import { getLocationName } from 'features/location/helpers';
import { CandidateViewModel } from 'features/profile/types';
import { useTranslation } from 'react-i18next';
import { EntityViewSectionTitle, InfoLine } from 'shared/components/layout/entityView';

export interface ContactDetailsSectionProps {
    email: string;
    mobilePhone: string | null;
    location: CandidateViewModel['location'];
}

export default function ContactDetailsSection({ email, mobilePhone, location }: ContactDetailsSectionProps) {
    const { t } = useTranslation('profile');

    return (
        <>
            <EntityViewSectionTitle
                title={ t('view.sections.contactDetails') }
                icon={ <ContactMailOutlined /> }
            />

            <InfoLine
                icon={ <MailOutlined /> }
                title={ t('fields.email') }
                description={ email }
            />
            <InfoLine
                icon={ <CallOutlined /> }
                title={ t('fields.mobilePhone') }
                description={ mobilePhone }
            />
            <InfoLine
                icon={ <LocationOnOutlined /> }
                title={ t('fields.location') }
                description={ getLocationName(location) }
            />
        </>
    );
}
